export default __webpack_public_path__ + "static/media/Stonewall-Gray-Charcoal.5c5d7003.jpg";